export const isInIframe = _ => {
    try {
        return window.self !== window.top
    } catch (e) {
        return true
    }
}
